import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const CookieNotice = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the cookie notice
    const acknowledged = localStorage.getItem('cookie-notice-acknowledged');
    if (!acknowledged) {
      // Show notice after a short delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcknowledge = () => {
    localStorage.setItem('cookie-notice-acknowledged', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur-sm border-t border-border shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1 text-sm text-foreground">
          <p className="font-medium mb-1">
            🍪 Informácia o cookies
          </p>
          <p className="text-muted-foreground">
            Táto stránka používa iba nevyhnutné cookies pre autentifikáciu a základnú funkčnosť.
            Nepoužívame analytické ani marketingové cookies.{' '}
            <Link to="/privacy" className="text-primary hover:underline font-medium">
              Viac informácií
            </Link>
          </p>
        </div>

        <div className="flex items-center gap-2">
          <Button
            onClick={handleAcknowledge}
            size="sm"
            className="whitespace-nowrap"
          >
            Rozumiem
          </Button>
          <Button
            onClick={handleAcknowledge}
            variant="ghost"
            size="sm"
            className="h-8 w-8 p-0"
            aria-label="Zavrieť"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
